import { styled, Box } from '@mui/material';
import { rem, Bold } from '@core-web/typography';

export const TooltipWrapper = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  position: 'relative',
  width: '100%',
  '&.show .tooltipBox': {
    display: 'flex',
  },
}));

export const TooltipBox = styled(Box)(({ theme: { palette } }) => ({
  display: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  minWidth: rem(150),
  backgroundColor: palette.colors.grey_900,
  position: 'absolute',
  bottom: `calc(100% + 10px)`,
  left: '50%',
  transform: 'translateX(-50%)',
  borderRadius: rem(4),

  '&::after': {
    content: '""',
    position: 'absolute',
    top: '100%',
    left: '50%',
    marginLeft: '-9px',
    borderWidth: '9px',
    borderStyle: 'solid',
    borderColor: palette.colors.grey_900 + ' transparent transparent transparent',
  },
}));

export const TooltipText = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  fontSize: rem(12),
  fontWeight: Bold._500,
  lineHeight: rem(18),
  color: palette.colors.white,
  cursor: 'text',
  padding: rem(8),
  textAlign: 'center',
}));

export const TooltipMainText = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  fontSize: rem(12),
  fontWeight: Bold._500,
  lineHeight: rem(18),
  color: palette.colors.grey_900,
}));
